"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEnvironmentJest() {
    return process.env.JEST_WORKER_ID !== undefined;
}
exports.default = isEnvironmentJest;
